import { Publisher } from './Publisher'
import { withPublisher } from './withPublisher'

const ConnectedPublisher = withPublisher(Publisher)

export { ConnectedPublisher as Publisher }
